import { render, staticRenderFns } from "./CndMunicipalView.vue?vue&type=template&id=bb7285f0&"
import script from "./CndMunicipalView.vue?vue&type=script&lang=js&"
export * from "./CndMunicipalView.vue?vue&type=script&lang=js&"
import style0 from "./CndMunicipalView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports